module.exports = __webpack_public_path__ + "img/banner05.1f99dcda.jpg";